export default __webpack_public_path__ + "static/media/3132 spice rack F side.4d595372.png";